import React from 'react';

const NumberOne = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="105" viewBox="0 0 31 105">
    <path fill="#303940" fillRule="evenodd" d="M1.8 17.76v-.12c-.96 0-1.8-.84-1.8-1.8V1.8C0 .84.84 0 1.8 0h26.52c.96 0 1.8.84 1.8 1.8v101.4c0 .96-.84 1.8-1.8 1.8H14.28c-.96 0-1.8-.84-1.8-1.8V19.56c0-.96-.84-1.8-1.8-1.8H1.8z" />
  </svg>
);

export default NumberOne;